import { Text } from "@/components/podkit/typography/Text";
import { type PlainRunner } from "@/queries/runner-queries";
import { type FC, type ReactNode } from "react";
import { RunnerPhaseTag } from "@/components/runners/RunnerPhaseTag";
import { LinuxRunnerAdditionalFieldsKeys } from "@/components/runners/details/runner-configuration-keys";

export const LinuxRunnerDetails: FC<{ runner: PlainRunner }> = ({ runner }) => {
    const dict = Object.fromEntries(runner.status?.additionalInfo.map((info) => [info.key, info.value]) || []);

    const os = dict[LinuxRunnerAdditionalFieldsKeys.OS] || "";
    const rootDiskSize = dict[LinuxRunnerAdditionalFieldsKeys.RootDiskSize] || "";
    const homeDiskSize = dict[LinuxRunnerAdditionalFieldsKeys.HomeDiskSize] || "";
    const kernel = dict[LinuxRunnerAdditionalFieldsKeys.Kernel] || "";
    const cores = dict[LinuxRunnerAdditionalFieldsKeys.Cores] || "";
    const memory = dict[LinuxRunnerAdditionalFieldsKeys.Memory] || "";
    const hostname = dict[LinuxRunnerAdditionalFieldsKeys.Hostname] || "";

    return (
        <div className="rounded-lg bg-surface-tertiary p-4 flex flex-col gap-2 overflow-x-hidden">
            <div className="flex flex-col gap-1 md:flex-row md:gap-2 items-center">
                <Text className="min-w-max text-base">Status: </Text>
                <div className="shrink truncate">
                    <RunnerPhaseTag runner={runner} />
                </div>
            </div>
            <Info label="Runner name">{runner.name}</Info>
            {os && <Info label="OS">{os}</Info>}
            {rootDiskSize && <Info label="Root disk size">{rootDiskSize}</Info>}
            {homeDiskSize && <Info label="Home disk size">{homeDiskSize}</Info>}
            {kernel && <Info label="Kernel">{kernel}</Info>}
            {cores && <Info label="Cores">{cores}</Info>}
            {memory && <Info label="Memory">{memory}</Info>}
            {hostname && <Info label="Hostname">{hostname}</Info>}
        </div>
    );
};

const Info: FC<{ label: string; children: ReactNode }> = ({ label, children }) => (
    <div className="flex flex-col gap-1 md:flex-row md:gap-2 items-center">
        <Text className="min-w-max text-base">{label}: </Text>
        <Text className="shrink truncate text-base font-bold">{children}</Text>
    </div>
);
